import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { Satellite } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = React.useState<string>('');

  const handleGoogleSuccess = async (credentialResponse: any) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/google`,
        { credential: credentialResponse.credential }
      );

      await login(response.data.token);

      if (!response.data.user.phoneVerified) {
        navigate('/setup');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Failed to login. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-8">
          <div className="flex flex-col items-center mb-6">
            <Satellite className="w-8 h-8 text-gray-900 mb-2" />
            <h1 className="text-2xl font-bold text-gray-900">AI Sat Text</h1>
            <p className="mt-2 text-sm text-gray-500 text-center">
              Access AI assistance via satellite SMS
            </p>
          </div>

          {error && (
            <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-sm text-red-700">{error}</p>
            </div>
          )}

          <div className="flex justify-center mb-4">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => setError('Google login failed')}
              useOneTap
            />
          </div>

          <p className="text-xs text-gray-500 text-center">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
